import React, { useState } from 'react';
import { Input, Button, HStack, Text } from '@chakra-ui/react';

const EditChoiceForm = ({ choice, onSave, onCancel }) => {
  const [text, setText] = useState(choice.text);
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!text.trim()) {
      setError('Choice text is required');
      return;
    }
    onSave({ text });
  };

  return (
    <form onSubmit={handleSubmit}>
      <Input
        type="text"
        value={text}
        onChange={e => {
          setText(e.target.value);
          setError('');
        }}
        placeholder="Choice text"
        mb={2}
        isInvalid={!!error}
      />
      {error && <Text fontSize="sm" color="red.500" mb={2}>{error}</Text>}
      <HStack>
        <Button type="submit" colorScheme="teal" size="sm">
          Update Choice
        </Button>
        <Button onClick={onCancel} size="sm">
          Cancel
        </Button>
      </HStack>
    </form>
  );
};

export default EditChoiceForm;
